module.exports = {
    navbar: {
        home: "首页",
        beta: "内测邀请",
        install: "安装",
        buy: "购买",
        mobile: "移动App下载",
        individual: "个人购买",
        team: "团队购买",
        help: "帮助",
        login: "登录",
        register: "注册",
        forgot_pass: "忘记密码",
        logout: "退出登录"
    },
    beta: {
        hero: {
            eyebrow: "Design Mirror v4 · 内测招募",
            title: "全新一代实时预览<br>邀你<span class=\"text-primary\">抢先体验</span>",
            description: "我们用全新架构重写了 Design Mirror —— 主攻大家反馈最多的「连不上」问题。现在诚邀你参与内测，<b>配合完成测试即赠送一年会员权益</b>。",
            cta: "加微信参与内测",
            note: "名额有限 · 配合测试赠送一年会员"
        },
        features: {
            title: "新版本带来了什么",
            description: "围绕「连接稳定性」做了彻底重构，并带来了原生 App 与更多设计工具支持。",
            list: [
                {
                    title: "连接稳定性大幅提升",
                    description: "全新多层设备发现：局域网 mDNS → 云信令 → 二维码 → USB 自动回退。换网络、公司网络隔离、复杂环境也能稳定连上。"
                },
                {
                    title: "USB 连接（免 Wi-Fi）",
                    description: "没有可用 Wi-Fi 或网络受限时，用数据线连接电脑也能实时预览，连接更快更稳。"
                },
                {
                    title: "全新原生 App",
                    description: "iOS 与 Android 全部用原生（SwiftUI / Kotlin）重写，界面更流畅、更省电，连接体验焕然一新。"
                },
                {
                    title: "覆盖更多设计工具",
                    description: "Photoshop / Sketch / Adobe XD / Figma / MasterGo / 即时设计 全部支持，一套 App 全搞定。"
                },
                {
                    title: "更快的实时同步",
                    description: "瓦片增量同步，只传输画面变化的部分，更新更快、更省流量，大长图也顺畅。"
                },
                {
                    title: "多设备同时预览",
                    description: "一台电脑可同时连接多部手机 / 平板，并排查看不同尺寸机型的适配效果。"
                }
            ]
        },
        reward: {
            title: "内测福利",
            description: "你的每一条反馈，都会直接影响产品的下一个版本。",
            items: [
                {
                    title: "一年会员权益",
                    description: "配合完成内测任务，即赠送一整年的 Design Mirror 会员。"
                },
                {
                    title: "需求优先实现",
                    description: "内测期间提出的问题与建议，我们会优先排期、优先修复。"
                },
                {
                    title: "直达开发者",
                    description: "加入内测专属交流群，遇到问题第一时间和开发者沟通。"
                }
            ]
        },
        conditions: {
            title: "我们希望你符合的条件",
            description: "为了让新版本在尽可能多的真实场景下都稳定可用，我们希望招募到的内测用户能覆盖<b>每一种设计工具、每一种操作系统、每一类手机设备</b>。",
            groups: [
                {
                    icon: "uil-palette",
                    title: "设计工具（任一）",
                    items: ["Photoshop", "Sketch", "Adobe XD", "Figma", "MasterGo", "即时设计"]
                },
                {
                    icon: "uil-desktop",
                    title: "电脑系统",
                    items: ["Windows 10 / 11", "macOS（Intel）", "macOS（Apple Silicon）"]
                },
                {
                    icon: "uil-mobile-android",
                    title: "手机系统",
                    items: ["iOS 15 及以上", "Android 9 及以上"]
                },
                {
                    icon: "uil-mobile-vibrate",
                    title: "手机品牌 / 机型",
                    items: ["iPhone 各机型", "小米 / Redmi", "华为 / 荣耀", "OPPO / 一加 / realme", "vivo / iQOO", "三星 及其他"]
                },
                {
                    icon: "uil-wifi",
                    title: "网络环境",
                    items: ["家庭 Wi-Fi", "公司 / 办公网络", "有隔离或防火墙的复杂网络"]
                }
            ],
            note: "不需要全部满足 —— 只要你日常常用其中一种「设计工具 + 电脑 + 手机」的组合，就非常欢迎报名！"
        },
        how: {
            title: "如何参与",
            steps: [
                {
                    title: "微信扫码加我",
                    description: "扫描下方二维码添加我的微信，备注「内测」。"
                },
                {
                    title: "告诉我你的环境",
                    description: "简单说明你常用的设计工具 + 电脑系统 + 手机型号。"
                },
                {
                    title: "领取安装包",
                    description: "我会发你最新内测安装包和详细的上手引导。"
                },
                {
                    title: "体验并反馈",
                    description: "按引导体验并反馈问题，完成内测即领取一年会员。"
                }
            ]
        },
        contact: {
            title: "扫码加我微信，参与内测",
            description: "长按或扫描下方二维码添加，备注「内测」，我会尽快通过并拉你进群。",
            qrhint: "微信扫一扫 · 备注「内测」",
            fallback: "如二维码无法识别，可搜索微信号或邮件联系：xiaoqiang@cutterman.cn"
        }
    },
    footer: {
        description: "Design Mirror是设计效率工具Cutterman旗下的另外一款产品，旨在服务广大设计师群体，为提高设计效率而生。",
        link: "相关链接",
        links: [
            {
                text: "Cutterman - 最好用的切图工具",
                link: "https://www.cutterman.cn"
            },
            {
                text: "打字鸭 - 免费在线打字网站",
                link: "https://www.daziya.com"
            },
            {
                text: "服务协议",
                link: "/terms"
            },
            {
                text: "隐私政策",
                link: "/privacy"
            },
        ]
    },
    index: {
        title: "实时预览您的设计",
        description: "超好用的设计稿预览工具，让您在移动设备上实时查看Ps/Sketch/XD/Figma中的设计图，稳定高效，提升你的工作体验",
        install: "开始使用",
        video: "观看演示视频",
        photoshop: "在Ps中进行预览，支持CC2018及以上版本，支持画布模式，即便是大长图也能够顺畅浏览",
        xd: "XD提供了桌面应用程序，能够实时监听到XD的内容变化，即便不用手机也可以在电脑上进行预览查看",
        sketch: "提供的Sketch插件，实时响应你的设计稿，预览功能更丰富，优于官方提供的预览工具",
        figma: "提供了桌面端，现在用Figma作图，也可以实时进行预览了，桌面，手机都能看",
        feature1: {
            title: "跨平台，多种设备支持",
            description: "Design Mirror支持多款主流设计软件，您可以在这些设计软件中享受相同的使用体验。移动端支持iPhone/Android设备，还支持微信小程序和web预览。让您再各种终端上感受设计的适配效果。",
            details: [
                "支持Windows/Mac操作系统",
                "支持Photoshop/Sketch/XD/Figma主流设计软件",
                "支持iphone/android/小程序/web预览",
                "支持同时链接多个手机设备，查看不同设备的适配效果"
            ]
        },
        feature2: {
            title: "Wifi多设备连接",
            description: "将电脑和手机连接到相同的wifi环境下, 打开App即可快速连接预览。支持多个设备同时连接，您可以将多台手机、平板等设备同时连接，同步预览，同步刷新。独创的电脑和手机双向通信机制，不用手动关防火墙也能连。",
            details: [
                "自动识别设备，不用手动输入ip",
                "支持多个设备同时链接，手机、平板、浏览器，同步刷新",
                "不用登录，扫码就能连，快速让他人查看效果",
            ]
        },
        feature3: {
            title: "支持USB连接，稳定快速",
            description: "当wifi网络不稳定的时候，您还可以通过USB连接电脑来进行预览，不需要复杂的设置，点击按钮即可使用，方便快捷。USB传输的速度更快，一边给设备充电一边预览。",
            details: [
                "将移动设备通过USB线插入电脑即可",
                "支持win/mac系统，支持ios/android设备",
                "传输速度更快，更稳定，无网络下的救命稻草",
            ]
        },
        app: {
            title: "贴心的功能特性",
            description: "App提供了丰富多样的功能，帮助你提升工作效率",

            features: [
                {
                    title: "随心缩放，完美适配",
                    description: "支持双指缩放、原始尺寸、适配屏幕等多种缩放方式，达到最称心的适配效果"
                },
                {
                    title: "多文档/多画布切换",
                    description: "画布再多，也可以快速选择，可以滑动切换，就和看相册照片那样容易"
                },
                {
                    title: "截屏快照&图像对比",
                    description: "可以将预览图保存到手机上，还可以将前后的截图做对比，选更优的方案"
                },
                {
                    title: "上传手机图片",
                    description: "支持将手机上的图片上传到电脑端，直接设计软件打开，务必快捷，从此告别QQ传图"
                },
                {
                    title: "离线文档，随时可查看",
                    description: "预览过的文档会保存在手机上，随时随地可以翻出来查看"
                },
                {
                    title: "好设计，分享给他人",
                    description: "支持将图片分享到各大社交媒体，好作品让更多人看见"
                }
            ]

        },
        signup: {
            title: "现在就开始使用吧",
            description: "免费注册账号，享受多平台多终端丝滑体验",
            email: "请输入邮箱地址",
            button: "注册账号"
        },
        price: {
            title: "价格与购买方式",
            description: "新用户默认享有15天的免费试用，请确认好用后再购买，会员享受免费升级和开发者技术支持。",
            plans: [
                {
                    title: "体验套餐",
                    currency: "￥",
                    price: 35,
                    sku_id: 13,
                    type: 0,
                    period: "/半年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "标准套餐",
                    currency: "￥",
                    sku_id: 14,
                    price: 60,
                    type: 0,
                    period: "/年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "优惠套餐",
                    currency: "￥",
                    sku_id: 15,
                    type: 0,
                    price: 100,
                    isBest: true,
                    period: "/2年",
                    feature: [
                        "不限平台/设计软件",
                        "技术支持，免费升级",
                        "限个人使用",
                        "发票开具",
                    ],
                    button: "购买",
                },
                {
                    title: "多人团购",
                    currency: "折",
                    sku_id:14,
                    type: 2,
                    price: 80,
                    period: "%",
                    feature: [
                        "不限平台/设计软件",
                        "10人以上8折优惠",
                        "技术支持，免费升级",
                        "发票开具",
                    ],
                    button: "购买",
                },
                /*
                {
                    title: "企业用户",
                    currency: "",
                    sku_id:100,
                    price: 60,
                    period: "/年",
                    feature: [
                        "统一账号管理",
                        "不限平台/设计软件",
                        "10份以上8折优惠",
                        "提供定制支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                 */
            ],
            enterprise: {
                title: "企业/团队购买",
                description: "对于企业或者团队，可以通过购买团队授权，将提供统一的账号管理功能，可以方便的管理团队用户，同时也可以享受团购优惠（10份以上8折）。",
                price: "价格： 60￥/年/人",
                feature: [
                    "统一账号管理，方便管理团队用户",
                    "不限平台/设计软件",
                    "10份以上8折优惠",
                    "提供技术支持，免费升级",
                    "支持开具发票",
                ],
                button: "购买",
            }
        },
        price_11: {
            title: "价格与购买方式",
            description: "双十一优惠大酬宾！永久授权限时回归，限时优惠，不容错过！",
            plans: [
                {
                    title: "Photoshop",
                    currency: "￥",
                    price: 60,
                    sku_id: 3,
                    type: 0,
                    period: "/永久",
                    feature: [
                        "限Ps中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Sketch",
                    currency: "￥",
                    sku_id: 4,
                    price: 60,
                    type: 0,
                    period: "/永久",
                    feature: [
                        "限Sketch中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Adobe XD",
                    currency: "￥",
                    sku_id: 5,
                    type: 0,
                    price: 60,
                    period: "/永久",
                    feature: [
                        "限XD中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                {
                    title: "Figma",
                    currency: "￥",
                    sku_id:17,
                    type: 0,
                    price: 60,
                    period: "/永久",
                    feature: [
                        "限Figma中使用",
                        "所有功能可用",
                        "限个人使用",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
            ],
        },
        contact: {
            title: "如何联系我们",
            description: "当您遇到使用问题或者有其它疑惑的时候，您可以通过如下方式联系我们",
            follow_title: "关注我们",
            details: [
                {
                    title: "微信技术支持",
                    description: "用微信扫描下面二维码，添加技术支持企业微信。技术支持和问题解答将得到快速满足。",
                    more: "<img alt='wechat coporate' class='img-fluid' width='200' src='images/index/wechat_qrcode_20260615.jpg'/>"
                },
                {
                    title: "微信公众号",
                    description: "用微信扫描下面二维码，关注官方公众号，公众号会不定期发布一些新产品，优惠活动等信息，千万不要错过。",
                    name: "wechat",
                    more: "<img alt='wechat coporate' class='img-fluid' width='200' src='images/index/wechat-cutterman.jpg?202305'/>"
                },

                /*
                {
                    title: "帮助和反馈平台",
                    description: "使用帮助和问题反馈平台，在这里你可以找到常见的问题解决办法，你也可以在这里提出你的想法和建议",
                    more: "<a class='text-primary' target='_blank' href='https://support.qq.com/products/360031'>点击了解详情>></a>"
                },
                {
                    title: "QQ交流群",
                    description: "在这里可以和众多用户进行使用交流，或者其它话题交流，也有官方开发者进行技术支持",
                    name: "qq",
                    follow: "点击关注>>"
                },
                 */
            ]
        }
    },
    signup: {
        title: "注册新账号",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        password: "密码",
        passwordTip: "密码长度至少6位",
        accept: "我接受",
        terms: "用户服务协议",
        signup: "注册",
        captcha: "验证码",
        captcha_tip: "输入右侧验证码",
        refresh_captcha: "换一个",
        haveAccount: "已经拥有账号了？",
        signIn: "点我登录",
        token: {
            title: "最后一步！",
            description: "已向邮箱<span class='badge badge-info'>{email}</span>发送了一份验证码邮件，请打开邮箱，在下面填入该验证码，即可完成注册。",
            token_tip: "请输入6位验证码",
            done: "完成注册",
            resend_token: "重发验证码",
            resend_tip: "已重新发送<br/>60s后可以再次发送",
            success: "注册完成，即将跳转..."
        }
    },
    login: {
        title: "登录",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        password: "密码",
        passwordTip: "密码长度至少6位",
        forgot_pass: "忘记密码？",
        no_account: "还没有账号？",
        signup: "去注册",
        login_success: "登录成功，现在跳转...",
        modal: {
            title: "请登录您的账号"
        }
    },
    reset_pass: {
        title: "重置密码",
        description: "请输入您的邮箱地址，以获取密码重置验证码",
        emailSend: "已发送一封验证码邮件到邮箱<strong>{email}</strong>，请查收邮件并将验证码填入下面输入框中。",
        email: "邮箱",
        emailTip: "请输入正确邮箱地址",
        newPass: "新密码",
        send: "发送",
        submit: "提交",
        successTip: "密码重置成功！",
        remember: "想起了密码？",
        login: "去登录"
    },
    photoshop: {
        title: "Photoshop插件安装",
        description: "Ps端插件，让您可以在Ps中查看当前的预览图，以及查看当前设备的连接状态。",
        version_support: "支持Mac苹果芯片电脑，最低支持到CC2018版本",
        download: "点击下载",
        version: "版本：",
        update_time: "更新时间：",
        install: {
            title: "安装指南",
            description: "请仔细阅读下面安装步骤",
            step1: {
                title: "下载并安装插件安装程序",
                detail: "解压后，是一个pkg/exe的安装程序，双击安装，接着一直下一步到完成就可以了。Mac系统需要您输入电脑的密码才可以哟。"
            },
            step2: {
                title: "Mac下无法打开安装程序的情况",
                detail: "mac系统在安装的时候，可能会弹出无法安装的提示框，如左图，这是因为mac系统没有打开第三方开发者的安装权限导致，请按照如下步骤操作：Mac系统 -> 首选项 -> 隐私 -> 通用，点击底部的'仍要打开'，如左图2"
            },
            step3: {
                title: "打开插件面板",
                detail: "安装完成后，重启Ps，接着从菜单栏 -> 窗口 -> 扩展 中找到 Design Mirror即可打开插件面板，在登录账号之后即可开始使用。"
            },
            step4: {
                title: "M1芯片的Mac找不到扩展入口",
                detail: "如果您用的是M1芯片的Mac电脑，且是最新的Ps2021/2022版本，会发现找不到上面扩展的选项，这是因为新版本默认废弃了就的插件架构，您可以通过如下方式打开它：找到应用程序 -> Adobe Photoshop 2022 -> Adobe Photoshop 2022 -> 右键 显示属性 -> 勾上 “用Rosetta方式打开”， 再重启Ps，就可以看到扩展入口了"
            },
        }
    },
    sketch: {
        title: "Sketch插件安装",
        description: "在Sketch中提供了插件面板，从此可以告别官方预览App了",
        version_support: "* 支持Sketch 100及以下的版本",
        download: "点击下载",
        install: {
            step1: {
                title: "安装并打开插件",
                detail: "解压后，是一个pkg的安装程序（不是.sketchplugin）的文件哟，双击安装，接着一直下一步到完成就可以了。\n安装完成后，重启Sketch，接着从菜单栏 -> 插件 -> Design Mirror打开插件面板，登录账号后即可开始使用。"
            }
        }
    },
    xd: {
        title: "Adobe XD插件安装",
        description: "感受XD的简约轻便，依然可以享受实时预览带来的乐趣。",
        version_support: "* 建议您使用最新版本的XD",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://product.cutterman.cn/devtools/990218cf_XD.xdx\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 下载XD的插件，双击安装",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'xd']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载桌面应用程序，双击安装",
                "安装完成后重启XD，在电脑应用程序中打开design mirror桌面客户端即可预览"
            ],
            step: {
                title: "下载并安装插件",
                detail: "解压后，文件夹中有两个安装程序文件，一个是xd的插件（xdx文件结尾），另外一个是桌面客户端（dmg/exe）文件",

            }
        }
    },
    figma: {
        title: "Figma插件安装",
        description: "没错，现在用Figma也支持使用Design Mirror进行预览了",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装Figma插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'figma']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载桌面应用程序，双击安装",
                "打开Figma插件和桌面应用程序，即可开始预览"
        ]}
    },
    jsdesign: {
        title: "即时设计插件安装",
        description: "支持国产！优秀的设计软件<strong>即时设计</strong>也可以使用Design Mirror进行预览了",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://js.design/community?category=detail&type=plugin&id=641aed2ff131d9846a1f1edc\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'jsdesign']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载桌面应用程序，双击安装",
                "打开即时设计插件和桌面应用程序，即可开始预览"
            ]}
    },
    mastergo: {
        title: "Mastergo插件安装",
        description: "在<strong>Mastergo</strong>设计软件上使用Design Mirror",
        download: "点击下载",
        install: {
            title: "安装步骤",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://mastergo.com/community/plugin/88358893523396\">点击这里 <i class=\"uil uil-external-link-alt\"></i></a> 从官方插件市场安装插件",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'mastergo']);\"  class=\"badge badge-primary\" >点击这里 <i class=\"uil uil-file-download\"></i></a> 下载桌面应用程序，双击安装",
                "打开mastergo插件和桌面应用程序，即可开始预览"
            ]}
    },
    mobile: {
        title: "移动端App下载",
        description: "目前支持iPhone/Android和微信小程序，您也可以通过手机上的浏览器扫一扫来进行预览。<br/><br/>您可以在各大应用市场搜索design mirror来找到app并下载。",
        modal: {
            title: "App下载",
            detail: "App请在各大应用商店上搜索<strong>Design Mirror</strong>进行安装。<br/>安卓设备也可以扫描下面的二维码进行安装。<span class='badge badge-info badge-pill'>(不要用微信扫，用浏览器扫码下载)</span>"
        },
        feature: {
            title: "功能特性",
            description: "App提供了丰富且易用的功能，让您的实时预览更方便"
        }
    },
    buy: {
        title: "价格与购买",
        description: "新用户可以享受15天的免费试用，试用期间可以体验完整功能，以让您对这个产品有足够&全面的了解。当认为它对您有帮助之后，可以选择付费购买更长时间的使用权益。",
        member_tip_title: "老用户权益变更",
        member_tip: "从2022/5/1日起，本产品由原先的单平台终身付费方式，改为全平台支持订阅付费制，已购买单平台终身制的用户请<a class='badge badge-light' href=\"/member-update\">点击这里</a>查看权益变更细则。"
    },
    help: {
        title: "帮助与支持",
        list: [
            {
                title: "Ps插件安装使用",
                id: "ps",
                detail: [
                    "<strong>1. 下载安装插件</strong>",
                    "从官网(https://www.psmirror.cn/)下载photoshop版本的插件安装程序，当前插件最低支持到CC2018版本，在安装之前，请先确认您的Ps版本是否符合要求，如果版本太低，请先升级Ps到最新。\n",
                    "<strong style='color: red'>注： 下载的时候不需要指定win/mac，页面已经自动根据您的操作系统，给您匹配不同系统的安装包</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_1.png\" alt=\"\" />",
                    "下载的压缩包解压之后就是安装程序，双击打开安装程序，一直下一步就行。" +
                    "<strong style='color: red'>注： mac系统在安装的时候，可能会弹出无法安装的提示框，如下</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_2.png\" alt=\"\" />",
                    "这是因为mac系统没有打开第三方开发者的安装权限导致，请按照如下步骤操作：" +
                    "Mac系统 -> 首选项 -> 隐私 -> 通用，点击底部的“仍要打开”",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_3.png\" alt=\"\" />",
                    "<strong>2. 打开插件面板\n</strong>" +
                    "安装完成之后，重启Ps，可以通过菜单栏 -> 窗口 -> 扩展 打开插件面板。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_4.png\" alt=\"\" />",
                    "<strong style='color: red'>注： 如果您用的是M1芯片的Mac电脑，且是最新的Ps2021/2022版本，会发现找不到上面扩展的选项，这是因为新版本默认废弃了就的插件架构，您可以通过如下方式打开它</strong>",
                    "找到应用程序 -> Adobe Photoshop 2022 -> Adobe Photoshop 2022 -> 右键 显示属性 -> 勾上 “用Rosetta方式打开”， 再重启Ps，就可以看到扩展入口了",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_5.png\" alt=\"\" />",
                ]
            },
            {
                title: "Sketch插件安装使用",
                id: "sketch",
                detail: [
                    "当我们需要链接Sketch进行预览的时候，需要安装Sketch上的插件，注意插件最低支持到<strong>Sketch70版本</strong>，<strong>支持M1芯片</strong>的电脑。",
                    "<strong>1. 下载安装插件</strong>",
                    "从官网(https://www.psmirror.cn/sketch)下载sketch版本的插件安装程序，注意插件最低支持到Sketch70版本，在安装之前，请先确认您的Sketch版本是否符合要求，如果版本太低，请先升级Sketch到最新。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_6.png\" alt=\"\" />",
                    "下载的压缩包解压之后就是安装程序，注意插件的安装程序是pkg文件，不是常见的sketch插件格式（*.sketchplugin)，只要双击打开安装程序，一直下一步就行。",
                    "<strong style='color: red'>注： mac系统在安装的时候，可能会弹出无法安装的提示框，如下</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_2.png\" alt=\"\" />",
                    "这是因为mac系统没有打开第三方开发者的安装权限导致，请按照如下步骤操作：" +
                    "Mac系统 -> 首选项 -> 隐私 -> 通用，点击底部的“仍要打开”",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_3.png\" alt=\"\" />",
                    "<strong>2. 打开插件面板</strong>",
                    "安装完成之后，重启Sketch，可以在菜单栏 -> 插件 -> Mirror 实时预览 中打开插件面板",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_9.png\" alt=\"\" />",
                    "接着登录您的账号，即可开始预览，如果没有账号，请到官网先进行注册",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_8.png\" alt=\"\" />",
                    "注意，预览期间，需要保持面板开着的状态，如果结束预览了，可以关闭此插件面板。"
                ]
            },
            {
                title: "XD插件安装使用",
                id: "xd",
                detail: [
                    "Design Mirror也支持Adobe XD进行实时预览，相比Ps和Sketch，XD多了一个桌面客户端面板。",
                    "<strong>1. 下载安装插件</strong>",
                    "从官网（https://www.psmirror.cn/xd) 下载安装程序，下载完成后解压，双击安装程序完成安装。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_10.png\" alt=\"\" />",
                    "<strong>2. 打开插件面板\n</srong>",
                    "安装程序都安装完成之后，重启XD，通过电脑的应用程序打开Design Mirror",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_11.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_12.png\" alt=\"\" />",
                ]
            },
            {
                title: "Figma插件安装使用",
                id: "figma",
                detail: [
                    "Figma的预览，需要安装Figma插件和桌面客户端。",
                    "<strong>1. 安装插件</strong>",
                    "a. 点<a href='https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror' target='_blank'>击此链接</a>，进入Figma的官方插件市场，点击安装即可。",
                    "b. 从官网（https://www.psmirror.cn/figma) 下载安装程序，下载完成后解压，双击安装程序完成安装。",
                    "<strong>2. 打开插件面板\n</srong>",
                    "先在Figma中打开插件面板",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_13.png\" alt=\"\" />",
                    "通过电脑的应用程序打开Design Mirror",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_11.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_12.png\" alt=\"\" />",
                    "注意，在预览期间，不能关闭Figma的插件面板。"
                ]
            },
            {
                title: "Wifi链接不上",
                id: "wifi",
                detail: [
                    "<strong>1. 确认插件安装是否正常</strong>",
                    "打开插件面板，如果能够正常更新设计图，说明插件安装正常，继续看后面的步骤。如果插件预览也不正常，说明插件安装可能有问题，请尝试重新安装插件。",
                    "如果Ps插件面板显示<strong>Photoshop没有连接</strong>，如下图，这种情况有可能是本地打开了VPN或者网络代理，如果是请关闭vpn并重启PS。如果本地没有开VPN，则先关闭插件再重启PS。",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_14.png\" alt=\"\" />",
                    "<strong>2. 确认手机和电脑是否链接在同一个网络</strong>",
                    "a.  您可以查看App首页的ip地址，和电脑ip做比对，看看是否链接到同一个网络。",
                    "<strong style='color: red'>注意： 有时候虽然链接的是同一个wifi，但是两个设备链接到了不同的路由器，跨了网段，也会导致无法链接，比如电脑的ip是 192.168.0.10，手机的ip是192.168.1.12，其中第三个字段0/1是不一样的，这就是跨网段的情况</strong>",
                    "b. 观察首页显示的IP，如果显示0.0.0.0，说明手机当前没有连接到Wifi，可能是连的4G之类的，也可能是当前App没有获取到网络权限。此时您可以关闭再打开wifi，查看系统设置里头，是否打开了App的网络权限。再最后杀掉App然后打开app。",
                    "<strong>3. 尝试手动输入ip</strong>",
                    "您可以在App连接的过程中（连接圈圈动画过程），在插件面板上手动输入手机上的ip进行连接",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_15.png\" alt=\"\" />",
                    "<strong>4. 关闭电脑的防火墙</strong>",
                    "windows系统有时候防火墙会阻止其它设备进行连接，您可以关闭系统的防火墙再试",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_16.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_17.png\" alt=\"\" />",
                    "<strong>5. 尝试使用USB连接</strong>",
                    "有时候，办公网络做了限制，虽然是连在了同一个网络，同一个网段，但是因为网络限制，设备之间依然无法通信，此时只能通过USB进行连接预览。"
                ]
            },
            {
                title: "USB连不上",
                id: "usb",
                detail: [
                    "<strong>1. 确认插件安装是否正常</strong>",
                    "打开插件面板，如果能够正常更新设计图，说明插件安装正常，继续看后面的步骤。如果插件预览也不正常，说明插件安装可能有问题，请尝试重新安装插件。" ,
                    "软件一直在持续更新中，遇到的问题可能已经被修复，您可以看看插件/App是否是最新的版本",
                    "<strong>2. Windows + Android</strong>",
                    "这是最常见的一种场景，这种情况大多数都是电脑没有识别出手机导致的",
                    "1. 先确保安卓手机打开了调试模式，如果不知道如何打开调试模式，请百度之",
                    "2. 在电脑上安装个手机助手类的软件，看看是否能够识别出手机，一般手机助手可以识别出来，Mirror也就能连上了。（注意：360助手会占据usb链接通道，建议卸载之）",
                    "<strong>3. Windows + iphone</strong>",
                    "windows要通过usb链接iphone手机，需要在电脑上安装iTunes，您可以通过官网下载 https://www.apple.com.cn/itunes/，安装完itunes之后打开，会自动识别出你的手机，之后就可以正常预览。",
                    "如果之前安装过itunes，打开itunes看是否能够识别出手机（识别出来的时候会在界面上显示一个手机icon），如果识别不出来，重装一下itunes就可以了",
                    "链接的时候，不需要itunes打开着",
                    "<strong>4. Mac + iphone/android</strong>",
                    "mac系统链接USB不需要其它依赖，如果无法正常连接，可能是线或者接口的问题，请尝试更换一下USB线或者其它接口再尝试。"
                ]
            },
            {
                title: "付费相关问题",
                id: "pay",
                detail: [
                    "<strong>1. 这个软件是收费的么？</strong>",
                    "是的，软件提供了15天的试用期，您可以在这期间尽情使用，觉得合适之后再进行购买。试用期的功能和购买后的功能是一致的。",
                    "<strong>2. 收费模式是什么样的</strong>",
                    "软件采用采用订阅式授权，试用到期后续购买才能继续使用。",
                    "订阅授权按照半年，一年，两年3中套餐不同的价格进行购买，订阅授权可以不限制使用软件和平台，Ps/Sketch/XD/Figma都可以使用。",
                    "<strong>3. 会员有什么权益</strong>",
                    "除了软件基本使用之外，产品免费升级，以及会员专属的技术支持和优先解决问题。<strong>不会出现无法链接干瞪眼的问题。</strong>",
                    "<strong>4. 如何进行购买</strong>",
                    "进入官网https://www.psmirror.cn，点击导航的购买链接，进入购买界面，可以选择自己想要的订阅套餐进行购买，当前只支持支付宝支付"

                ]

            },
            {
                title: "联系技术支持",
                id: "contact",
                detail: [
                    "<strong>联系我们寻求帮助</strong>",
                    "请用微信扫码下面二维码，加入官方群进行咨询",
                    "<img alt='wechat coporate' class='img-fluid' width='200' src='images/index/wechat_qrcode_20260615.jpg'/>"
                ]
            }
        ]
    },
    member: {
        title: "权益变更说明",
        description: "针对已购买过终身授权的用户",
        overview: {
            title: "变更说明：",
            content: "至<b class='text-danger'>2022年5月1日</b>起，Design Mirror授权方式，从之前的<strong class='text-primary'>单平台终身授权</strong>更换为<strong class='text-primary'>全平台订阅授权</strong>方式。对于已经购买过某平台下终身授权的用户，涉及到已购买的授权是否发生变化和将要购买其它平台时如何付费等问题，下文将详细说明。",
            title1: "名词解释",
            content1: "<b>单平台终身授权</b>指的是每个平台(Ps/Sketch/XD/Figma）需要单独购买，一次购买终身使用。",
            content2: "<b>全平台订阅授权</b>指的是按照时间订阅的方式进行购买授权，购买后该账号全平台（Ps/Sketch/XD/Figma）都可以使用。",
            title3: "已购的授权是否有效？",
            content3: "已经购买过的终身授权，继续有效，仅对该平台终身有效。",
            title4: "购买其它平台如何授权？",
            content4: "购买新平台的授权，将采用订阅授权的方式，订阅授权针对所有剩余未购买的平台有效。",
            title5: "老用户优惠政策",
            content5: "为感谢老用户信任与支持，对已购买过某平台授权的用户，购买其它平台订阅授权享受首年优惠政策：",
            desc1: "1. 已经购买了Ps&Sketch&XD三个平台终身授权的用户，不再需要购买Figma，自动终身使用",
            desc2: "2. 已经购买了任意两个平台终身授权的用户，购买剩余两个平台的订阅授权，首年享受<b class='text-danger'>4折优惠</b>",
            desc3: "3. 已经购买了任意一个平台终身授权的用户，购买剩余三个平台的订阅授权，首年享受<b class='text-danger'>6折优惠</b>",
            desc4: "4. 2/3两个优惠政策，仅针对<b class='text-danger'>标准套餐</b>有效"
        },
        faq: {
            title: "常见问题：",
            list: [
                {
                    q: "我已经购买了Ps的终身授权，是不是也要变成订阅按年付费？",
                    a: "不会，已经购买过的终身授权，依然有效。",
                },
                {
                    q: "我已经购买了Ps的终身授权，购买Sketch是否要按年付费？是否会影响我的Ps终身授权？",
                    a: "购买新的平台，都将采用年度付费方式，但不会影响已购买的终身授权平台。即Ps依然终身使用，新购买的订阅付费授权对剩下的平台（Sketch/XD/Figma）生效。",
                },
                {
                    q: "我已经购买了Ps和Sketch和XD三个平台的终身授权，是否还需要购买Figma？",
                    a: "不用，为感谢用户的支持，已经购买过3个平台终身授权的用户，自动赠送Figma的终身授权。",
                },
                {
                    q: "我购买了的账号，可以和别人共用么？",
                    a: "不能，账号仅自己使用，一个账号会有登录设备的限制，超过设备登录会导致功能无法链接，账号被列入异常等。",
                }
            ]
        }

    },
    cart: {
        title: "订单确认",
        param_error: "参数错误",
        order: {
            name: "商品名称",
            description: "描述",
            price: "价格",
            number: "份数",
            created_at: "创建时间",
            total: "总计",
            checkout: "支付宝付款",
            not_exists: "订单没有找到，即将跳转到购买页面"
        },
        group_order: {
            title: "团购账号信息",
            name: "一年期授权",
            email: "账号",
            add: "请添加团购用户的邮箱",
            add_button: "添加",
            remove: "删除"
        },
        org: {
            title: "添加组织成员",
            add: "请添加组织成员的邮箱",
            add_info: "1. 成员账号可以不用预先注册，也不需要保证真实存在，不能添加已经存在的账号，如需要请联系我们处理。<br/>2. 只针对子账号进行授权，当前账号默认为管理员账号，不做软件授权。<br/>3. 组织成员至少需要存在两个及以上。",
            name: "请为组织设置一个名称",
            submit: "提交",
            count: "购买数量",
            count_tip: "组织授权数量不能少于2个",
            auth_owner: "授权当前账号",
            auth_tip: "* 购买后会自动生成指定数量的子账号，不授权当前购买的账号",
            email_suffix: "邮箱后缀",
            email_tip: "可以为子账号设置统一的邮箱后缀",
        },
        pay_modal_title: "请使用支付宝扫码支付",
        status_title: "支付状态确认",
        status_success: "已完成支付",
        status_fail: "支付遇到问题",
        repay: "重新支付",
        success: {
            title: "购买成功！",
            detail: "感谢您的支持，我们会持续为您的效率提升而努力，您可以关注我们的公众号，微博以及时获取软件的更新和优惠活动信息。如果您遇到了使用问题，可以加入我们的官方QQ群寻求技术支持。",
        },
        fail: {
            title: "订单未支付",
            detail: "如果您在支付时遇到问题，或者支付完成了依然没有授权，请即刻通过下面的反馈渠道联系我们。",
        },
        home: "返回首页",
        qq: "官方QQ群",
        weixin: "微信公众号",
        weibo: "官方微博"
    },
    profile: {
        email_invalid: "您的邮箱还没有经过验证，请在<a href='javascript:void(0)' class='badge badge-dark'>设置界面</a>进行验证。",
        info: {
            title: "基本信息",
            description: "这里是您账号的基本信息，如果需要修改账号信息，请在<strong>设置</strong>TAB中进行修改。",
            email: "邮箱",
            status: {
                title: "账号状态",
                non_active: "邮箱未验证",
                non_active_tip: "请在设置tab进行邮箱有效性验证",
                active: "正常",
                block: "被锁定",
                block_tip: "账号已被锁定，请联系官方处理"
            },
            name: "名称",
            phone: "手机号",
            no_phone: "未设置",
            no_phone_tip: "设置后可以用手机号登录，找回账号等",
        },
        profit: {
            title: "权益",
            description: "这里显示的是您当前拥有的软件使用权益情况。",
            app: "App",
            auth_status: "权益状态",
            auth_trial: "试用期",
            auth_expired: "已过期",
            auth_subscribe: "已订阅",
            auth_lifetime: "永久使用授权",
            end_time: "到期时间",
            purchase_time: "授权时间"
        },
        order: {
            title: "订单",
            description: "以下是您购买的订单信息，",
            ticket: "需要开具发票？",
            ticket_title: "如何开具发票",
            ticket_detail: "微信扫描二维码加入官方群，联系群主开具发票。",
            id: "订单号",
            name: "名称",
            detail: "详细",
            price: "价格",
            created_at: "时间",
            status: "状态",
            buyer: "付款人",
            operation: "操作",
            pay: "去支付",
            delete: "删除",
            status_0: "未支付",
            status_1: "已支付",
            status_2: "支付中",
            status_3: "已关闭",
            status_4: "退款/转移",
        },
        device: {
            title: "设备",
            description: "显示您账号登录过的电脑设备信息，由于账号有设备登录数量限制，当超过数量之后，您可以在这里进行设备的删除操作。<span class='badge badge-pill badge-info'>名称标识</span>可以用来标记这台设备以便于理解，您可以按需要自行定义。",
            app: "App",
            os: "系统",
            mac: "MAC/IP地址",
            created_at: "时间",
            name: "名称标识",
            op: "操作",
            remove: "删除",
            modal_ok: "提交",
            modal_title: "自定义名称标识",
            name_tip: "名称标识必须由英文字母和数字组成，特殊字符可以有(-_.@#)",
            format_error: "名称格式不正确"
        },
        enterprise: {
            title: "组织",
            description: "这里显示的是您当前所在的组织信息，以及该组织下的成员。您可以对组织下的成员进行管理，包括添加、删除、修改等操作。",
            name: "组织名称",
            members: "成员列表",
            save: "保存",
            quota: "配额 (已用/总共)",
            add_quota: "增加配额",
            email: "账号",
            password: "密码",
            last_access_time: "最近使用时间",
            action: "操作",
            cancel: "取消"
        },
        setting: {
            title: "设置",
            email: "邮箱",
            email_tip: "* 修改邮箱后需要重新验证",
            name: "用户名",
            phone: "手机号",
            avatar: "头像",
            save: "保存修改",
            select_avatar: "选择头像",
            upload_avatar: "上传头像",
            change_password: "修改密码",
            new_password: "新密码",
            new_password_repeat: "再次输入密码",
            save_password: "保存密码",
            password_tip: "密码至少6位",
            select_done: "选好了",
            select_cancel: "取消",
            upload: "完成",
            upload_tip: "点击/拖拽图片到这里(<1M)",
            password_info: "* 密码修改后，各终端登录状态会被踢出",
            email_validate: "邮箱验证",
            email_validate_tip: "您的邮箱需要验证才能继续使用",
            send_code: "发送验证码",
            code_input_tip: "验证码已发送至邮箱<span class='badge badge-info badge-pill'>{email}</span>，请打开邮箱查看，并在下面填写6位验证码完成验证。如果没有收到邮件，请确认邮箱地址是否正确或者尝试重新发送。",
            code_submit: "验证",
            code_resend: "重发验证码"
        },
        logout: {
            title: "退出登录"
        }
    },
    terms: {
        title: "服务协议",
        time: "更新时间： 2022年2月7日",
        description: ["Design Mirror是由北京灵动无线网络科技有限公司(以下简称“灵动无线” 或“我们”)提供的互联网软件服务(以下简称“本产品”)。本服务协议(以 下简称“本协议”)是您(以下简称“您”或“用户”)与灵动无线之间关于您访问和使用Desing Mirror以及灵动无线提供的其他服务的协议。", "在本服务创建账户并使用之前，您必须首先同意本协议。在接受本协议之前， 请您仔细阅读全部内容，如您无法准确理解或不同意本协议的任一内容，请不要访问、使用我们提供的其他任何服务。您通过网络⻚面点击确认、 实际购买或使用本服务等操作均表示您已阅读并充分理解本协议之内容，具有达成本协议所需的民事权利能力和民事行为能力(或您符合本协议中“青少年特别协议”部分的要求)，与灵动无线就使用或订购相应产品和/或服务已达成合作意向，并同意接受本协议的全部约定内容，受其约束。","特别提示您关注本协议关于限制、免除灵动无线责任的协议、对用户的权利限制协议、违规/违约行为的认定处理、以及管辖法院的选择等协议内容，前述协议可能以加粗及/或加下划线形式提示您注意。", "您同意灵动无线有权不时地对本协议进行修订。修订后的协议将在网⻚上公布的方式向您告知，并代替原来的服务协议。您继续访问和使用本产品即视为您接受修订后的服务协议。如您不同意修订后的全部或者部分服务协议内容，您有权通过停止访问本网站或者拒绝使用相应软件服务等方式以终止服务协议或者使修订后的内容不对您生效。", "如果您代表某个机构而非您个人注册、登录和使用本产品，则您将被认为获得该机构的充分授权，有权代表该机构同意本服务协议以及服务协议不时的修改和补充。"],
        content: [
            {
                title: "服务内容",
                content: [
                    "本协议中的“本产品”指:灵动无线向您提供psmirror.com网站(即官网)上所展示的产品和服务，包括但不限于通过网⻚、移动端APP等方式提供的全部服务，具体服务内容以您所使用或订购的内容为准。",
                    "若您未从灵动无线官方途径获取服务的，我们无法保证该服务能够正常使用，我们对此种获取方式和使用行为造成的损失不承担任何责任。",
                    "根据实际需要和灵动无线不时提供的其他服务内容，我们可能与您另行签订其他协议(“其他协议”)。同时，即使未另行签订其他协议，您使用本产品的具体服务也将被视为您同意我们关于该等具体服务的任何要求。如果其他协议和本协议之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。",
                    "灵动无线保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整本产品提供的免费服务种类、形式的权利。灵动无线不承担因本产品提供的任何免费服务的调整给您造成的损失。灵动无线有权在未来恰当的时机对任何免费服务内容收取相应的服务费用。灵动无线做出上述调整前会以站内通知、邮件或官网公告等方式通知您，并给予您合理期限以完成数据的下载和备份。免费版服务可能在功能或者体验上有所限制，您可以通过开通付费版解除该等限制，具体信息以官网描述为准",
                    "您在使用本产品服务前，应充分阅读并理解本产品官网对相应服务的描述，尤其是对免费服务、各级收费服务在功能、服务标准上的限制。对由于您未能充分理解上述描述和限制而造成的任何损失，我们不承担任何法律责任。"
                ]
            },
            {
                title: "账户",
                content: [
                    "为使用本产品，您必须注册一个账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行更新。您对(a)您的账户的保密性，以及用于启用您访问服务的任何密码、身份验证密钥或安全凭据的安全性负责，和(b)所有在您账户下的活动，不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，请您立即通知我们。您认可并同意我们不会对您账户中任何未经授权或滥用行为负责，除非这是由我们违反本协议所造成的。",
                    "灵动无线和您应遵守相关法律法规进行实名认证。就本产品的使用，灵动无线可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关服务。您理解并同意灵动无线有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效，对于违反本协议约定的账户信息，灵动无线有权采取不予通过、屏蔽或删除等处理。您知晓并同意，如您未依照相关法律法规及灵动无线的要求完成实名认证，将影响您访问或使用本服务。",
                    "您声明并保证，您向灵动无线提供的信息均为真实、准确、有效、最新的，否则您应承担由此产生的一切法律责任。尽管有前述规定，灵动无线无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核 实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。",
                    "灵动无线建议您妥善保管您的注册邮箱、手机号、密码和名称，准确输入该等信息将作为您访问登录本产品并享有服务的关键环节。如果您发现有人未经授权使用您的账户信息或怀疑任何人未经授权可能能够访问您的私有内容，您应立即更改密码，并向我们反馈。",
                ]
            },
            {
                title: "使用",
                content: [
                    "您声明并保证您上传或储存在本产品中的内容不违反本协议并且符合法律法规。您应对您上传或储存的内容的合法性、准确性、完整性和可靠性负责。 您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非 法律另有明确规定，否则灵动无线不承担任何与您上传或储存的内容有关的义务和责任。若您在本产品上传、储存侵犯他人知识产权或其他违法、违规的内容，灵动无线有权利予以删除并保留移交司法机关处理的权利。",
                    "您不得使用本产品上传、储存、共享、发送或传播任何敏感信息和违反国家 法律法规的信息，包括但不限于下列信息:<br/>" +
                    "- 反对宪法所确定的基本原则的;\n<br/>" +
                    "- 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的; - 损害国家荣誉和利益的;\n<br/>" +
                    "- 煽动⺠族仇恨、⺠族歧视，破坏⺠族团结的;\n<br/>" +
                    "- 破坏国家宗教政策，宣扬邪教和封建迷信的;\n<br/>" +
                    "- 散布谣言，扰乱社会秩序，破坏社会稳定的;\n<br/>" +
                    "- 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;\n<br/>" +
                    "- 侮辱或者诽谤他人，侵害他人合法权益的;\n<br/>" +
                    "- 含有法律、行政法规禁止的其他内容的。\n<br/>" +
                    "  您承诺发表言论要:爱国、守法、自律、真实、文明。不传播任何非法的、\n<br/>" +
                    "骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽 的、危害国家安全的、泄露国家机密的、破坏国家宗教政策和⺠族团结的 以及其它违反法律法规及政策的内容。若您的行为不符合以上提到的服务协议。我们将作出独立判断立即暂停或终止您的服务账号。您需自行对其全部行为承担法律责任，我们不承担任何法律责任。",
                    "您不得发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商 业秘密等合法权利的内容。",
                    "您不得制作、复制、发布、传播涉及他人隐私、个人信息或资料的信息。",
                    "您不得发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的内容。",
                    "您应当对您使用本产品的一切行为及所有在您账户下的活动(不论是您还是您授权他人的活动)负责。您不得利用本产品从事违反法律法规、违反本用户协议约定、危害网络安全、危害计算机系统安全、破坏产品完整性或其他侵害任何第三人利益的活动。若您从事了上述行为，灵动无线有权暂停或终止您的账户，并拒绝您于现在和未来使用本产品，由此对灵动无线或第三人造成的损失或由此产生的一切法律责任均由您全部承担。"
                ]
            },
            {
                title: "内容和知识产权",
                content: [
                    "您在本产品提交的内容之所有权归您所有。您明白灵动无线对您提供的任何内容不在任何方面负责，灵动无线没有义务预先审查此类内容。但是，我们有权随时决定您提供的任何内容是否符合相关法律规定或本协议的相关约定，并可随时预先审查、转移、拒绝、修改和/或删除您上传的内容，而不需事先通知您。若您使用本服务的行为存在或涉嫌任何违反国家法律法规或侵犯任何第三方合法权益的情形，灵动无线有权直接删除该等违反规定的信息，并可以暂停或终止向您服务。",
                    "本产品的所有权及所有与本产品服务相关的知识产权(包括但不限于源代码、目标代码、文档资料、界面设计、版面框架、以及任何由灵动无线根据维护与技术支持提供的软件、资料等)归灵动无线所有。您认同灵动无线拥有的所有权及知识产权，并承诺尊重及不以任何方式侵害灵动无线对本产品享有的所有权及知识产权。未经灵动无线书面许可，您不能复制、拷⻉、 转让、许可或提供他人使用上述知识成果，或者私自使用任何部分代码和外观设计，否则您应承担相应的法律责任，且灵动无线有权终止服务且不退还任何费用。"
                ]
            },
            {
                title: "隐私政策",
                content: [
                    "您在使用本产品前，通过阅读和点击同意《隐私政策》并实际使用本服务，即表示您授权灵动无线合法收集和使用有关您及您所使用本服务的技术性或诊断性信息。基于提供服务所必需，手机端用户仅在用于反馈建议和问题时调用录音、拍照、读取相册等权限。收集到的这些信息将用于改进本产品服务的内容和技术，提升我们的服务品质。灵动无线不会将您的信息和内容分享或出售给第三方。但以下情况除外:<br/>" +
                    "- 基于特定的服务目的且事先获得您的明确授权;\n<br/>" +
                    "- 遵守适用的法律法规;\n<br/>" +
                    "- 遵守法院命令或其他法律程序的规定;\n<br/>" +
                    "- 遵守相关政府主管部⻔的要求;\n<br/>" +
                    "- 与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的情 形下;\n<br/>" +
                    "- 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信 息公开等渠道;\n<br/>" +
                    "- 灵动无线认为为遵守适用的法律法规、维护社会公共利益、或保护灵动无线的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需 的情形下;\n<br/>" +
                    "- 您违反了本服务协议，且灵动无线出于维权需要向第三方提供的情形 下;\n<br/>" +
                    "- 法律法规规定的其他情形。<br/>",
                    "保护用户个人信息是灵动无线的一项基本原则，灵动无线将按照《隐私政策》的约定收集、使用、储存和分享您的个人信息，以及您如何管理您的个人信息、我们如何采取必要措施保障您的个人信息安全、我们响应您的权利请求等。您声明并保证，您已仔细阅读、完全理解并同意上述 《隐私政策》的全部内容。若您不同意本协议及《隐私政策》， 请您立即停止使用我们提供的任何服务或产品。"
                ]
            },
            {
                title: "数据和信息安全",
                content: [
                    "我们与您共同负有维护账号安全的责任。我们在目前的技术水平下努力保护您的账号在服务器端的安全，并不断更新技术措施。但互联网并非绝对安全的环境，我们特别提醒您应该妥善保管您的账号和密码，杜绝私自转借乃至出售账号等有害于账号安全的行为。此外，灵动无线建议您采用复杂字符组合设定您的账号密码。请您理解，灵动无线不对因您自身有违相关法律法规规定和本协议约定使用账号的行为及其所导致的数据未经授权访问、泄露、破坏乃至销毁等造成的损失承担责任。",
                    "灵动无线将依照法律、行政法规的规定和国家标准的强制性要求，采取合理的技术措施和其他必要措施，努力保护您的数据和信息安全。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全⻛险，该等⻛险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的⻛险和后果， 并已采取恰当的措施(例如数据备份等)，以便在该等⻛险发生时将损失 降至最低。",
                    "您知悉并认可，本产品服务是基于第三方云服务所提供的SAAS服务，鉴于网络服务的特殊性(包括但不限于云服务器的稳定性问题、通讯基础设施 故障、网络黑客攻击、政府管制等行为的存在及其他我们无法控制的情形)，我们提供的服务可能会出现中断、不能及时传送信息或其他不能满足您的要求的情况，请您知悉并理解，该情况将不视为我们违反本协议约定，但我们将尽可能及时通过网页公告、系统通知、短信或者其他合理的方式通知您。"
                ]
            },
            {
                title: "免责声明",
                description: "您知悉并同意，下列情况下，灵动无线无需向您承担任何责任:",
                content: [
                    "由于您维护不当或保密不当，导致数据、资料、口令、密码等丢失或泄漏，或其他非因灵动无线原因导致的个人信息的泄漏，灵动无线不承担任 何法律责任;",
                    "任何由于不可抗力、黑客攻击、电脑病毒侵入、网络运营商原因或政府管制等灵动无线无法合理控制的原因而造成本产品使用中止、中断、延误、使用限制、使用异常、使用不能、暂时性网站关闭等，灵动无线不承担任何法律责任;",
                    "您应对通过本产品上传或储存文件、输入数据的合法性以及获得文件、数 据、内容的方式的合法性负责，因上述文件、数据、内容引发的一切纠纷，由您承担全部法律责任，灵动无线不承担任何法律责任;",
                    "互联网是一个开放平台，如果您将图片、文字等内容上传并传播，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，您应充分意识 到此类⻛险的存在。您同意使用灵动无线服务所存在的此类⻛险及后果将完全由您自己承担，灵动无线不承担任何责任。",
                    "您理解并确认，受技术所限，灵动无线无法保证其所提供的服务毫无瑕疵，但我们承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意:如果灵动无线所提供的服务虽然存在瑕疵，但该等瑕 疵是当时行业技术水平所无法避免的，其将不被视为违约，灵动无线无须因此向您承担任何责任。",
                    "我们通过中华人民共和国境内的设施提供服务，我们无法确保您的使用行为、发布的信息及内容在其他国家或地区是适当的、可行的，当您在其他 司法辖区使用本软件及相关服务时，您应自行确保其遵守当地的法律法规，我们对此不承担任何责任。",
                    "如我们发现、或通过第三方举报或投诉获知，您发布的内容存在或涉嫌违反国家法律法规或本软件规则的，我们有权依据合理判断不经通知立即采取一切必要措施(包括但不限于立刻删除您所发布的相关内容、冻结账户封号、向公安机关报案等)或配合国家网信部门、公检法等国家机关的执法要求对帐户做相应处理以减轻或消除您行为所造成的影响。"
                ]
            },
            {
                title: "服务变更/中断/终止",
                content: [
                    "您可随时注销您的账户并停止使用本产品服务。注销账户的方式可遵照官网的指引。您声明并保证，在您自主注销账户前已经将您上传、储存在本产品中的数据下载、备份完毕。您自主注销账户并经过缓冲期后，我们将不再负有保留您数据的任何法定或者约定义务。",
                    "您理解并同意，如因系统维护或升级的需要而暂停本产品服务、调整服务功能的，灵动无线将尽可能事先在网站上进行通告，以便于您提前做好商业安排，努力将对您带来的实际影响降到最低，但不因此承担任何法律责任。",
                    "当出现如下任一情形时，灵动无线可径行终止或暂停您使用所有或部分账 户和/或本服务<br/>" +
                    "- 您提供的资料不真实，或违反其他用户个人资料提供规则;\n<br/>" +
                    "- 您违反法律法规、本协议或您与灵动无线的其他约定;\n<br/>" +
                    "- 您要求取消或终止您的账户;\n<br/>" +
                    "- 未经灵动无线同意，将本产品产品用于商业目的或者其他任何营利性用 途;\n<br/>" +
                    "- 您对本产品的访问或使用可能会对本产品服务、灵动无线或第三方造成安全 ⻛险;\n<br/>" +
                    "- 需要听从法庭传票、法律命令或遵循法律程序;\n<br/>" +
                    "- 根据相关法律法规或政府机构的要求;\n<br/>" +
                    "- 因自然灾害、战争等不可抗力;\n<br/>" +
                    "- 本协议发生变更或修改，您不同意变更或修改后的用户协议。<br/>",
                    "您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国 家重大技术、法规政策等变化，灵动无线不保证永久地提供某种服务，或可能变更所提供服务的形式、规格或其他方面，在终止该种服务或进行此种变更前，灵动无线将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知;如终止提供该种服务的，灵动无线将尽合理的努力给您预留合理的时间，妥善处理后续事宜。",
                    "一旦您的账户被终止，您将无法正常使用本服务。此外，您可以选择在账户终止前删除您的账户下的所有信息和内容。"
                ]
            },
            {
                title: "本服务协议的完善和修改",
                content: [
                    "灵动无线有权根据互联网的发展和中华人⺠共和国有关法律、法规的变化， 不时地完善和修改本协议。灵动无线保留随时修改本协议的权利，并会将修改后的服务协议在官网上公布，您有义务及时查看官网上的消息更新，该等公布行为即可被合理地视为对您进行了有效通知送达。您在使用灵动无线的服务时，有必要对最新的《服务协议》进行仔细阅读和重新确认，经您确认和同意后，当发生相关争议时，以最新的服务协议为准。",
                    "如果您不同意灵动无线对本协议所做的修改，您应立即停止使用本产品服务。如果用户继续使用本产品服务，则视为用户接受我方对本协议所做的修改。"
                ]
            },
            {
                title: "⻘少年特别协议",
                content: [
                    "本产品服务主要面向成年人。若您是未成年人，请您确保您的监护人已仔细阅读、理解并接受本协议。并在征得您的监护人同意的前提下使用本产品服务或向灵动无线提供信息。",
                    "如您的监护人不同意您按照本协议使用本服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。",
                    "您声明并保证，您是具有完全⺠事行为能力的自然人。若您违背上述保证购买、使用本产品付费服务的，灵动无线不因此承担任何包括但不限于返还价款在内的任何法律责任，由此造成的损失应由您或您的监护人自行承担。"
                ]
            },
            {
                title: "法律适用及争议解决",
                content: [
                    "本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用 中华人⺠共和国大陆法律;如法律无相关规定的，参照商业惯例或者行业惯例",
                    "您因使用本产品服务所产生及与本协议有关的一切争议，由灵动无线与您协商解决。协商不成时，任何一方均可向灵动无线住所地人⺠法院提起诉讼。",
                    "若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，灵动无线不承担任何法律责任。因此给灵动无线或任何第三方造成任何损失的，用户应负责全额赔偿。"
                ]
            },
            {
                title: "联系我们",
                content: [
                    "当您有其他的投诉、建议或反馈时，请与我们联系。您可以将您的问题发送至 xiaoqiang@cutterman.cn，或通过官网提供的联系渠道与我们反馈。",
                    "北京灵动无线网络科技有限公司",
                    "邮箱： xiaoqiang@cutterman.cn",
                    "QQ：687356463",
                    "微博： cutterman"
                ]
            }
        ]

    },
    privacy: {
        title: "隐私政策",
        time: "更新时间 2022年02月07日",
        content: []
    }

}
